import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/internal/Observable";
import { AuthenticateRequestModel } from "@model/authenticate.model";


@Injectable({
    providedIn: "root",
})
export class AuthenticateApiService {

    constructor(private http: HttpClient) {
    }

    Authenticate(authenticateRequestModel: AuthenticateRequestModel): Observable<any> {
        return this.http.post<any>("/Login",authenticateRequestModel);
    }


}
